import axios from 'axios'

export default  {
  namespaced: true,

  state: {
    authorizationItems: null,
  },

  mutations: {
    getAuthorizationItemsSuccess(state, authorizationItems) {
      state.authorizationItems = authorizationItems
    },
  },

  actions: {
    // find({commit}, id) {
    //   return new Promise((resolve, reject) => {
    //     axios.get(`/medico/rol-tuss-codes/${id}`)
    //       .then((res) => {
    //         resolve(res.data.data.rol_tuss_code)
    //       })
    //       .catch((error) => {
    //         reject(error)
    //       })
    //   })
    // },

    create({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/medico/rol-tuss-codes', data)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    update({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/medico/rol-tuss-codes/${data.id}`, data)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getAuthorizationItems({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/medico/rol-tuss-codes/authorizations-list')
          .then(res => {
            commit('getAuthorizationItemsSuccess', res.data.data.datas)
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {
    authorizationItems: (state) => state.authorizationItems
  }
}
